import InvoiceCard from "@molecules/ObjectCard/ObjectCards/InvoiceCard/InvoiceCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function InvoiceCardsView() {
    return (
        <CardsView.List<Invoice>>
            {(invoice, displayedAttributes) => (
                <InvoiceCard invoice={invoice} displayedAttributes={displayedAttributes} />
            )}
        </CardsView.List>
    )
}
